import { render, staticRenderFns } from "./AuthBasicLayout.vue?vue&type=template&id=6029226e"
import script from "./AuthBasicLayout.vue?vue&type=script&lang=js"
export * from "./AuthBasicLayout.vue?vue&type=script&lang=js"
import style0 from "./AuthBasicLayout.vue?vue&type=style&index=0&id=6029226e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports